import { Button } from "@mui/material";
import PlaylistRemoveRoundedIcon from '@mui/icons-material/PlaylistRemoveRounded';

const ClearButton = ({ children, className, color="secondary", variant="outlined", ...props}) => {
 return (
  <Button startIcon={<PlaylistRemoveRoundedIcon />} color={color} variant={variant} {...props} type="reset">{children}</Button>
 )
}

export default ClearButton;